import Button from "app/components/Button";
import { CloseIcon } from "app/components/Icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import React, { useState } from "react";
import { ChromePicker } from "react-color";
import { fixedTagsColorCode } from "./data";
import { ColorPlateProps } from "./types";

const TagsColorPlate: React.FC<ColorPlateProps> = ({
  trigger,
  color,
  updateColor,
}) => {
  const [open, setOpen] = useState(false);
  const [colorCode, setColorCode] = useState("");
  return (
    <div className=" relative ">
      <Popover open={open} onOpenChange={setOpen} modal={false}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          alignOffset={50}
          className="bg-white border border-gray-100 flex flex-col gap-4 p-4 shadow-lg rounded-md "
          onOpenAutoFocus={(e) => e.preventDefault()}
          onCloseAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
          onPointerDownOutside={(e) => e.preventDefault()}
          onFocusOutside={(e) => e.preventDefault()}
        >
          <div className=" flex flex-row items-center justify-between gap-4 ">
            <span className="text-xs text-black font-medium">Color</span>
            <button onClick={() => setOpen(false)}>
              <CloseIcon />
            </button>
          </div>
          <ChromePicker
            onChange={(newColor) => {
              setColorCode(newColor.hex);
            }}
            color={colorCode}
            style={{ boxShadow: "none" }}
          />
          <Button
            onClick={() => {
              updateColor(colorCode);
              setOpen(false);
            }}
            disabled={!colorCode}
          >
            Save
          </Button>
          <span className=" text-gray-700 text-xs font-medium ">
            Saved colors:
          </span>
          <div className="flex flex-wrap gap-2">
            {fixedTagsColorCode.map((clr, index) => (
              <div
                key={index}
                className={`${
                  clr === color
                    ? ` border rounded-full flex justify-center items-center size-7 `
                    : ""
                }  `}
                style={{ borderColor: clr }}
              >
                <div
                  className="size-6 rounded-full cursor-pointer"
                  style={{ backgroundColor: clr }}
                />
              </div>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default TagsColorPlate;
